/**
 * `sync.studyGroups.group(id).meta.*` — group metadata reads + owner-only update.
 */

import type { StudyGroupMeta } from '@flashka/shared/sync-engine/schema/group-entities';

import { useStudyGroupStore } from '../internal/store/study-group-store';
import { nowISO, sendSG } from './helpers';
import type { SGScopedGroup } from './types';

export function createMetaApi(groupId: string): SGScopedGroup['meta'] {
  return {
    use: () => useStudyGroupStore((s) => s.groups[groupId]?.meta),
    get: () => useStudyGroupStore.getState().groups[groupId]?.meta,
    update: (patch) => {
      const current = useStudyGroupStore.getState().groups[groupId]?.meta;
      if (!current) return;
      const now = nowISO();
      const next: StudyGroupMeta = { ...current, ...patch, updatedAtISO: now };
      useStudyGroupStore.getState().setMeta(groupId, next);
      sendSG(groupId, {
        type: 'sg-meta-push',
        sgMeta: next,
        updatedAtISO: now,
      });
    },
  };
}
